(function () {
  'use strict';

  if (window.__FastShopifyNavigation) return;
  window.__FastShopifyNavigation = true;

  var cache = new Map();
  var MAX_CACHE = 0; // Never serve a stale page after a theme/content change.
  var activeRequest = null;
  var navigating = false;

  function isEligibleLink(link) {
    if (!link || !link.href) return false;
    if (link.dataset.noFastNav !== undefined) return false;
    if (link.target === '_blank' || link.hasAttribute('download')) return false;
    if (link.getAttribute('rel') === 'nofollow') return false;
    if (link.closest('form')) return false;

    var url;
    try { url = new URL(link.href, location.href); } catch (e) { return false; }

    if (url.origin !== location.origin) return false;
    if (url.pathname === location.pathname && url.search === location.search) return false;
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;

    // Keep Shopify cart, checkout, customer/account and search flows native.
    if (/^\/checkout(?:\/|$)/.test(url.pathname)) return false;
    if (/^\/cart(?:\/|$)/.test(url.pathname)) return false;
    if (/^\/account(?:\/|$)/.test(url.pathname)) return false;
    if (/^\/search(?:\/|$)/.test(url.pathname)) return false;
    if (/^\/challenge(?:\/|$)/.test(url.pathname)) return false;

    // Don't hijack file/data/javascript URLs or links with explicit download intent.
    if (/\.(pdf|zip|csv|xlsx?|docx?|pptx?|mp4|webm|mov)(?:$|\?)/i.test(url.pathname)) return false;

    return true;
  }

  function setLoading(on) {
    document.documentElement.classList.toggle('fast-nav-loading', on);
  }

  function updateHead(doc) {
    if (doc.title) document.title = doc.title;

    var newCanonical = doc.querySelector('link[rel="canonical"]');
    var canonical = document.querySelector('link[rel="canonical"]');
    if (newCanonical && canonical) canonical.href = newCanonical.href;

    var newDescription = doc.querySelector('meta[name="description"]');
    var description = document.querySelector('meta[name="description"]');
    if (newDescription && description) description.content = newDescription.content;
  }

  function updateActiveNavigation(url) {
    var targetUrl = new URL(url, location.href);
    var targetPath = targetUrl.pathname.replace(/\/+$/, '') || '/';

    document.querySelectorAll('header a[href]').forEach(function (link) {
      var href = link.getAttribute('href');

      if (!href || href.charAt(0) === '#' || href.indexOf('javascript:') === 0) {
        return;
      }

      var linkUrl;

      try {
        linkUrl = new URL(link.href, location.href);
      } catch (e) {
        return;
      }

      if (linkUrl.origin !== targetUrl.origin) return;

      var linkPath = linkUrl.pathname.replace(/\/+$/, '') || '/';
      var isActive = linkPath === targetPath;

      /* Link active state */
      link.classList.toggle('active', isActive);
      link.classList.toggle('is-active', isActive);

      if (isActive) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.removeAttribute('aria-current');
      }

      /* Dawn active menu text */
      var activeText = link.querySelector('.header__active-menu-item');

      if (activeText) {
        activeText.classList.toggle('header__active-menu-item', isActive);
      }

      /* If Dawn uses the parent span/text element */
      var textElements = link.querySelectorAll('span');

      textElements.forEach(function (span) {
        if (
          span.classList.contains('header__active-menu-item') ||
          span.classList.contains('header__menu-item')
        ) {
          span.classList.toggle('header__active-menu-item', isActive);
        }
      });
    });
  }

  function loadStyles(main) {
    main.querySelectorAll('link[rel="stylesheet"]').forEach(function (oldLink) {
      var href = oldLink.href;
      if (!href) return;
      if (!document.querySelector('link[rel="stylesheet"][href="' + CSS.escape(href) + '"]')) {
        var link = oldLink.cloneNode(true);
        link.setAttribute('data-fast-nav-style', '');
        document.head.appendChild(link);
      }
    });
  }

  function runScripts(main) {
    var scripts = Array.from(main.querySelectorAll('script'));

    scripts.forEach(function (oldScript) {
      var src = oldScript.src;
      if (src) {
        var absolute = new URL(src, location.href).href;
        if (document.querySelector('script[src="' + CSS.escape(absolute) + '"]')) return;

        var script = document.createElement('script');
        script.src = absolute;
        script.async = false;
        script.defer = false;
        script.setAttribute('data-fast-nav-script', absolute);
        document.head.appendChild(script);
      } else if (oldScript.textContent.trim()) {
        // Re-run inline section scripts after the section has been replaced.
        var script = document.createElement('script');
        script.textContent = oldScript.textContent;
        document.body.appendChild(script);
        script.remove();
      }
    });
  }

  function executePageScripts(main) {
    // Give the browser one frame to connect custom elements before initializing scripts.
    requestAnimationFrame(function () {
      runScripts(main);
      document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: main.id || 'MainContent' } }));
      document.dispatchEvent(new CustomEvent('fastnav:loaded'));
    });
  }

  function store(url, html) {
    if (MAX_CACHE <= 0) return;
    cache.delete(url);
    cache.set(url, html);
    while (cache.size > MAX_CACHE) cache.delete(cache.keys().next().value);
  }

  async function fetchPage(url) {
    if (cache.has(url)) return cache.get(url);
    var freshUrl = new URL(url, location.href);
    freshUrl.searchParams.set('_fastnav', Date.now().toString());
    var response = await fetch(freshUrl.href, {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Cache-Control': 'no-cache' }
    });
    if (!response.ok) throw new Error('Navigation request failed: ' + response.status);
    var html = await response.text();
    store(url, html);
    return html;
  }

  async function navigate(url, push) {
    if (navigating) return;
    navigating = true;
    setLoading(true);

    try {
      var html = await fetchPage(url);
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newMain = doc.querySelector('#MainContent');
      var currentMain = document.querySelector('#MainContent');

      if (!newMain || !currentMain) throw new Error('MainContent not found');

      updateHead(doc);
      loadStyles(newMain);

    // Remove old product media modals that Dawn moved outside #MainContent.
    // Otherwise fast navigation can leave stale modals from the previous product page,
    // causing product image clicks to open the wrong modal or do nothing.
    document.querySelectorAll('product-modal').forEach(function (modal) {
      modal.remove();
    });

    // Also clean up any stale product media modal backdrops/dialogs if present.
    document.querySelectorAll('.product-media-modal').forEach(function (modal) {
      modal.remove();
    });

      // Keep header/footer/cart drawer alive; replace only the page content.
      currentMain.replaceWith(newMain);

      if (push) history.pushState({ fastNav: true }, '', url);

      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      executePageScripts(newMain);

      if (typeof window.initGabBlog === 'function') {
        window.initGabBlog();
      }
      
      updateActiveNavigation(url);

    } catch (error) {
      // Always retain normal Shopify navigation as a safe fallback.
      location.href = url;
      return;
    } 
    finally {
      setLoading(false);
      navigating = false;

      // Safety cleanup after navigation as well.
      document.body.classList.remove(
        'overflow-hidden-mobile',
        'overflow-hidden',
        'menu-open'
      );

      document.documentElement.classList.remove(
        'overflow-hidden',
        'menu-open'
      );

      document.querySelectorAll(
        'header-drawer details[open], menu-drawer details[open]'
      ).forEach(function (details) {
        details.removeAttribute('open');
      });

      // Safety cleanup for the custom-header mobile nav too (covers
      // browser back/forward navigation via popstate).
      document.querySelectorAll('.mobile-nav.is-open').forEach(function (nav) {
        nav.classList.remove('is-open');
      });
      document.querySelectorAll('.mobile-nav-overlay.is-open').forEach(function (overlay) {
        overlay.classList.remove('is-open');
      });
      document.body.style.overflow = '';
    }
  }

  function prefetch(link) {
    if (!isEligibleLink(link)) return;
    var url = new URL(link.href, location.href).href;
    if (cache.has(url) || activeRequest === url) return;

    activeRequest = url;
    fetchPage(url).catch(function () {}).finally(function () {
      if (activeRequest === url) activeRequest = null;
    });
  }

  /* =========================================================
   SAME-PAGE SECTION NAVIGATION
   Do NOT run Fast Navigation for #section links
   ========================================================= */

document.addEventListener('click', function (event) {
  if (event.defaultPrevented || event.button !== 0) return;

  if (
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  ) return;

  var link = event.target.closest('a');

  if (!link || !link.href) return;

  var url;

  try {
    url = new URL(link.href, location.href);
  } catch (e) {
    return;
  }

  /*
   * Only handle same-page hash links.
   * Example:
   * /pages/consultation#book-consultation
   */
  if (
    url.origin !== location.origin ||
    url.pathname !== location.pathname ||
    url.search !== location.search ||
    !url.hash
  ) {
    return;
  }

  var target = document.querySelector(url.hash);

  if (!target) return;

  event.preventDefault();
  event.stopPropagation();

  /*
   * Update URL without reloading/re-rendering the page
   */
  history.pushState(
    {
      fastNav: true,
      anchor: url.hash
    },
    '',
    url.href
  );

  /*
   * Let the browser finish the click/layout first,
   * then smoothly scroll to the section.
   */
  requestAnimationFrame(function () {
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });

}, true);

document.addEventListener('click', function (event) {
  if (event.defaultPrevented || event.button !== 0) return;

  if (
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  ) return;

  var link = event.target.closest('a');

  if (!link || !link.href) return;

  /*
   * IMPORTANT:
   * If the click is from the mobile/header drawer,
   * close the drawer IMMEDIATELY before AJAX navigation.
   */
  var isDrawerLink = link.closest(
    'header-drawer, menu-drawer, .menu-drawer, .mobile-nav'
  );

  if (isDrawerLink) {
    event.preventDefault();

    // Close drawer synchronously
    forceCloseMobileMenu();

    // Now perform SPA/AJAX navigation
    navigate(
      new URL(link.href, location.href).href,
      true
    );

    return;
  }

  /*
   * All other eligible links continue using
   * Fast Navigation normally.
   */
  if (!isEligibleLink(link)) return;

  event.preventDefault();

  navigate(
    new URL(link.href, location.href).href,
    true
  );
}, false);

function forceCloseMobileMenu() {
  // Close all header drawer details immediately
  document.querySelectorAll('header-drawer').forEach(function (headerDrawer) {
    var mainDetails = headerDrawer.querySelector(
      '#Details-menu-drawer-container'
    );

    if (mainDetails) {
      // Remove open state immediately
      mainDetails.removeAttribute('open');

      // Remove Dawn animation/open classes
      mainDetails.classList.remove('menu-opening');
      mainDetails.classList.remove('submenu-open');

      // Close all nested submenus
      mainDetails.querySelectorAll('details').forEach(function (details) {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });

      // Reset all aria states
      mainDetails
        .querySelectorAll('[aria-expanded="true"]')
        .forEach(function (element) {
          element.setAttribute('aria-expanded', 'false');
        });
    }
  });

  // Remove Dawn header open state
  document.querySelectorAll('.section-header').forEach(function (header) {
    header.classList.remove('menu-open');
  });

  // Close the site's custom mobile nav (custom-header section), which uses
  // its own .is-open classes instead of Dawn's <details> drawer.
  document.querySelectorAll('.mobile-nav').forEach(function (nav) {
    nav.classList.remove('is-open');
  });
  document.querySelectorAll('.mobile-nav-overlay').forEach(function (overlay) {
    overlay.classList.remove('is-open');
  });
  document.querySelectorAll('.menu-toggle').forEach(function (toggle) {
    toggle.setAttribute('aria-expanded', 'false');
  });

  // Remove body scroll lock
  document.body.classList.remove('overflow-hidden-mobile');
  document.body.classList.remove('overflow-hidden-tablet');
  document.body.classList.remove('overflow-hidden-desktop');
  document.body.style.overflow = '';

  // Remove any drawer-related focus/overflow state
  document.documentElement.classList.remove('overflow-hidden');
}

  document.addEventListener('mouseover', function (event) {
    var link = event.target.closest('a');
    if (link) prefetch(link);
  }, { passive: true });

  document.addEventListener('touchstart', function (event) {
    var link = event.target.closest('a');
    if (link) prefetch(link);
  }, { passive: true });

  window.addEventListener('popstate', function () {
    navigate(location.href, false);
  });
})();
